module.exports = __webpack_public_path__ + "static/media/jumping_laddu.a85d2cdc.gif";